import type { ReactNode } from 'react';

export const symbol_edit_location_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-552q0-150 96.5-239T480-880q25 0 48.5 3.5T575-866q12 4 18 14.5t2 22.5q-4 12-14.5 18t-22.5 2q-19-6-38.5-8.5T480-820q-109 0-184.5 75T220-552q0 75 65 173.5T480-159q133-121 196.5-219.5T740-552q0-18-1.5-35t-1.5-33q-3-12 3-23t18-14q12-3 23 3t14 18q2 20 3.5 41t1.5 43q0 94-70 203T520-115q-8 8-18.5 11.5T480-100q-11 0-21.5-3.5T440-115q-42-38-91-87.5T258-309q-42-57-70-119t-28-124Zm320 0Zm47 4 230-230q5-5 5-11t-5-11l-34-34q-5-5-11-5t-11 5L471-604q-5 5-7 10t-2 11v21q0 9 6.5 16t15.5 7h22q6 0 11-2t10-7Zm262-284q5 5 11 5t11-5l19-19q8-8 8-19t-8-19l-18-18q-8-8-19-8t-19 8l-19 19q-5 5-5 11t5 11l34 34Z"
		/>
	</svg>
);
